<template>
  <div class="relative bg-gray-50 rounded-xl p-6 border overflow-hidden">
    <dt>
      <div class="absolute bg-blue-500 rounded-md w-12 h-12 flex text-white">
        <i :class="icon" class="m-auto text-lg"></i>
      </div>
      <p class="ml-16 text-sm font-medium text-gray-500 truncate" v-text="label"></p>
    </dt>
    <dd class="ml-16 flex items-baseline">
      <p class="text-2xl font-semibold text-gray-900" v-text="value"></p>
    </dd>
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    label: String,
    icon: String,
  }
}
</script>
